import { Component, Inject, Injectable, NgModule, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventService } from "../../core/services/event.service";
import { createS3Client, createCognitoCredentials, createUpload } from '../../utils/aws-s3.util';

// utils function
import { environment } from "src/environments/environment";
import { UploadService } from '../../core/services/upload.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DataService } from '../../core/services/data.service';
import { ImageCroppedEvent, ImageCropperComponent, base64ToFile } from 'ngx-image-cropper';
import { Observable, ReplaySubject } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { AuthService } from 'src/app/core/services/auth.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PhotowallService } from 'src/app/core/services/photowall.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-upload-event-qr',
  templateUrl: './upload-event-qr.component.html',
  styleUrls: ['./upload-event-qr.component.css']
})
export class UploadEventQrComponent implements OnInit {

  @ViewChild(ImageCropperComponent)
  imageCropper!: ImageCropperComponent;
  compressedb64Image: any;
  compressed: any;
  selectedFiles: File | null = null;
  default_qrcode: boolean = true;
  delayTimeInMilliseconds = 8000; // 8 seconds delay
  eventId: any;
  eventData: any;
  imgBlob: any;
  totalImages: any;
  eventDetail: any
  isLoading = false;
  errorMessage: any = null;
  isFileLoading = false;
  selectedFileNames: string[] = [];
  uploadedCheck: boolean | undefined;
  count: any;
  imageSrc: any = localStorage.getItem('qrcode');
  prevImage: any = null;
  userId: any;
  uploadProgress: { [key: string]: number } = {};
  thumbnailUrls: string[] = [];
  progressPercentage: any;
 // private s3: AWS.S3;
  localFiles: string[] = [];
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageURL!: SafeUrl;
  base64Output: any;
  hideBtn: boolean = false;
  currentFile?: File;
  progress = 0;
  message = '';
  preview = '';
  qr_image: any = null;
  imageInfos?: Observable<any>;
  formGroup!: FormGroup;
  showMessage: string = '';
  fileTypeError: boolean = false;
  isSavingData: boolean = false;
  isFileUploaded = false;
  isbtnDisabled: boolean = true;
  eventName: any;
 private identityPoolId: string = environment.aws.IdentityPoolId;

  constructor(
    public dataService: DataService,
    public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<UploadEventQrComponent>,
    private photoService: PhotowallService,
    public dialog: MatDialog, private location: Location,
    private authService: AuthService,
    private router: Router,
    private platform: Platform, private fb: FormBuilder, public fbAuth: AngularFireAuth,
    @Inject(MAT_DIALOG_DATA) public data: { eventId: any, userId: any }
  ) {
    this.formGroup = this.fb.group({
      showQRCode: [false],
      textAboveQRCode: ['']
    });

    this.eventId = data.eventId;
    this.userId = data.userId;
    this.imageSrc = localStorage.getItem('qrcode');
  

  }


  async ngOnInit() {
    // console.log('Event ID:', this.eventId); //__CONSOLE_LOG__
    
    this.isSavingData = true;
    this.isbtnDisabled = true;
    ((this.photoService.getEventQR(localStorage.getItem('e')))).subscribe({
      next: (res: any) => {
        // console.log(res); //__CONSOLE_LOG__
        if (res) {
          localStorage.setItem('eventId', res.hash);
          localStorage.setItem('qrcode', res.qrCode);
          localStorage.setItem('name', res.event_name);
          this.eventName = res.event_name;
        }
      }
    });
    (this.photoService.gethashtags(localStorage.getItem('e'))).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        if (res.result == 'Data not available!') {
          this.default_qrcode = true;
        }
        else {
          let response: any;
          response = res;
          // if (response.show_qrcode) {
          this.formGroup.patchValue({
            showQRCode: response.show_qrcode,
            textAboveQRCode: (response.qrcode_subtext !== "null" && response.qrcode_subtext !== undefined) ? response.qrcode_subtext : ''
          });
          this.default_qrcode = response.default_qrcode === 1 ? true : false;
          // console.log(this.default_qrcode) //__CONSOLE_LOG__
          this.imageSrc = response.qr_image;
          if (this.default_qrcode == true) {
            this.imageSrc = localStorage.getItem('qrcode');
          }
          else {
            this.prevImage = response.qr_image;
          }
          //  }
        }

        this.isSavingData = false;
      }
    });
    // console.log(this.formGroup.value); //__CONSOLE_LOG__
    // this.formGroup.get('showQRCode')?.valueChanges.subscribe(value => {
    //  // this.textChange();
    //   if (!value) { // if the toggle is switched to off
    //     this.formGroup.value.showQRCode = false;
    //     this.saveQRCodeData(false,null,true);
    //   }
    //   else{
    //     this.textChange();
    //   }
    // });

    // this.formGroup.get('textAboveQRCode')?.valueChanges.subscribe(value => {
    //   this.textChange();
    // });
  }

  selectFile(event: any): void {
    this.message = '';
    this.preview = '';
    this.progress = 0;
    this.selectedFiles = event.target.files;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles;

      if (file) {
        this.preview = '';
        this.currentFile = file;

        const reader = new FileReader();
        reader.onload = e => this.imageSrc = reader.result;
        reader.onload = (e: any) => {
          // console.log(e.target.result); //__CONSOLE_LOG__
          this.preview = e.target.result;
        };

        reader.readAsDataURL(this.currentFile);
      }
    }
  }

  closeDialog(files: any): void {
    this.dialogRef.close(files);
  }

  textChange(event: any): void {
    // console.log(event); //__CONSOLE_LOG__
    if (event != null && !event.checked) {
      // if the toggle is switched to off
      this.formGroup.value.showQRCode = false;
      this.saveQRCodeData(false, null, true);
      this.isbtnDisabled = true;
    }
    else {
      this.isbtnDisabled = false;
    }

  }

  readURL(event: any): void {
    if (event.target) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      this.currentFile = file;
      reader.readAsDataURL(file);
    }
  }

  async onFileSelected(event: any) {
    this.isFileUploaded = true;
    this.isbtnDisabled = false;
    this.errorMessage = null;
    this.hideBtn = false;
    this.imageChangedEvent = event;
    this.selectedFiles = event.target.files[0] as File;
    const fileType = this.selectedFiles.type;

    if (fileType !== 'image/png' && fileType !== 'image/jpeg' && fileType !== 'image/webp') {
      this.fileTypeError = true;
      event.target.value = ''; // Clear the input
    } else {
      this.fileTypeError = false;
      // Handle the valid file upload logic here
      this.selectedFileNames = [];
      this.uploadProgress[this.selectedFiles.name] = 0;
      this.selectedFileNames.push(this.selectedFiles.name);
      this.prevImage = null;
      this.default_qrcode = false;
      this.readURL(event);
    }
  }

  removeImage() {
    this.isbtnDisabled = false;
    this.imageSrc = localStorage.getItem('qrcode');
    this.default_qrcode = true;
    this.selectedFiles = null;
  }


  blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // console.log(theBlob); //__CONSOLE_LOG__

    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return theBlob as File;
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event: any) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  async uploadImage() {
    this.count = 0;
    this.isFileLoading = true;
    this.errorMessage = null;
    this.isSavingData = true;
    this.isbtnDisabled = true;
    //let qr_image = null;
    const showQRCode = this.formGroup.value.showQRCode;
    if (showQRCode) {
      this.uploadedCheck = false;
      if (this.selectedFiles != null) {
        this.default_qrcode = false;
        this.qr_image = this.selectedFiles.name.replace(/\s+/g, '_');
        await this.uploadFile(localStorage.getItem('e'), this.selectedFiles, this.qr_image)
          .then(async (data) => {
            // console.log("File uploaded successfully:", data); //__CONSOLE_LOG__
            this.showMessage = "File uploaded successfully!"
            this.selectedFiles = null;
            this.default_qrcode = false;
          })
          .catch((error) => {
            // console.error("Error uploading file:", error); //__CONSOLE_LOG__
            this.showMessage = "Error uploading file!"
          });
      }
      await this.saveQRCodeData(showQRCode, this.qr_image, this.default_qrcode);
    }
    else {
      await this.saveQRCodeData(showQRCode, this.qr_image, this.default_qrcode);
    }


  }

  async saveQRCodeData(showQRCode: any, qr_image: any, default_qrcode: any): Promise<void> {
    if (showQRCode) {
      const subtext = (this.formGroup.value.textAboveQRCode !== undefined || this.formGroup.value.textAboveQRCode !== null) ? this.formGroup.value.textAboveQRCode : '  ';
      // console.log(this.formGroup.value); //__CONSOLE_LOG__

      (await this.photoService.saveQRCodeData(localStorage.getItem('e'), showQRCode, subtext, qr_image, default_qrcode)).subscribe({
        next: (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;
          this.showMessage = response['result'];
          this.isSavingData = false;
        }
      });

    }
    else {
      (await this.photoService.saveQRCodeData(localStorage.getItem('e'), showQRCode, '', qr_image, default_qrcode)).subscribe({
        next: (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;
          this.showMessage = response['result'];
          this.isSavingData = false;
        }
      });
    }
  }


  async uploadFile(eventId: any, file: File, fileName: any): Promise<any> {
    //let fileName = file.name;
    const currentUser = await this.fbAuth.currentUser;
    if (!currentUser) {
      throw new Error("No authenticated user found.");
    }
    const firebaseToken = await currentUser.getIdToken(true);
    const region = 'us-west-1';
    const s3 = await createS3Client({
      region,
      credentials: await createCognitoCredentials({
        identityPoolId: this.identityPoolId,
        logins: {
          'securetoken.google.com/picaggo-235807': firebaseToken
        },
        clientConfig: { region }
      })
    });
    const params = {
      Bucket: environment.aws.bucketName,
      Key: "photo-wall/event-qrcode/" + eventId + "/" + fileName,
      Body: file,
      //Metadata: metadata
    };
    const upload = await createUpload({ client: s3, params });
    upload.on("httpUploadProgress", (progress) => {
      if (progress.loaded && progress.total) {
        this.uploadProgress[file.name] = Math.round(
          (progress.loaded / progress.total) * 100
        );
      }
      // console.log(this.uploadProgress[file.name]); //__CONSOLE_LOG__
    });

    try {
      const data = await upload.done();
      // console.log("Upload complete:", data); //__CONSOLE_LOG__
      return data;
    } catch (error) {
      // console.error("Error uploading:", error); //__CONSOLE_LOG__
    }
  }


  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    localStorage.removeItem('eventId');
    this.location.back();
  }


  async downloadApp() {
    const info = await Device.getInfo();

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }

    if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
      window.location.href = 'https://picaggo.com';
    }
  }




}

